import { AppDispatch } from "integrations/redux/store"
import { showGlobalModal } from "runlevel/actions"
import { resetOverlayAction, setWorkspaceConfirmationModalContext } from "./slice"
import { WorkspaceConfirmationContext } from "./types"

export function closeModal() {
    return (dispatch: AppDispatch) => {
        dispatch(resetOverlayAction())
    }
}

export function showConfirmationModal(context: WorkspaceConfirmationContext) {
    return (dispatch: AppDispatch) => {
        dispatch(setWorkspaceConfirmationModalContext(context))
        dispatch(showGlobalModal())
    }
}
